var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('side-menu'),_c('div',{staticClass:"content main__content col-xs-9 col-sm-9"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")]),_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }